import { getToken } from '../utils/utils';

import axios from 'axios';
import get from 'lodash.get';

const baseURL = process.env.REACT_APP_TELEMEDICINE_API_URL;
const client = axios.create({ baseURL });

const TokenInterceptor = config => {
	config.headers['Authorization'] = `Bearer ${getToken()}`;

	return config;
};

client.interceptors.request.use(TokenInterceptor);

client.interceptors.response.use(
	response => Promise.resolve({ data: response.data.data }),
	error => Promise.resolve({ error: get(error, 'response.data.message', error.message) })
);

export default client;
